import { TemplateType } from '@/types/boot';
import { isMobileDevice } from '@/utils/device';

export const isInlineScreenSurface = (templateType?: TemplateType): boolean =>
  templateType === TemplateType.EMBEDDED_VIEW || !isMobileDevice();

/**
 * Clears whichever surface `useScreenSurface().openScreen` wrote to: the
 * in-place viewer on desktop / EMBEDDED_VIEW, the mobile drawer otherwise.
 * Screens call `drawer.closeDrawer` for both, so a controller that only clears
 * the drawer leaves a desktop viewer screen stuck open.
 */
export const closeScreenSurface = (
  templateType: TemplateType | undefined,
  setViewer: (screen?: undefined) => void,
  setDrawerScreen: (screen?: undefined) => void
): void => {
  if (isInlineScreenSurface(templateType)) {
    setViewer(undefined);
  } else {
    setDrawerScreen(undefined);
  }
};
